var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carousel",style:(!_vm.isMobile || 'height:auto;')},[_c('div',{staticClass:"page page_01",style:(!_vm.isMobile || 'height:auto;')},[_c('img',{attrs:{"src":"https://mp-lelight.oss-cn-guangzhou.aliyuncs.com/pic/ic_home_top_bg.png","alt":"carousel"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }